import { Component, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { MenuBarComponent } from '../../../core/components/menu-bar/menu-bar.component';
import { ImageCarouselComponent } from '../../../core/components/image-carousel/image-carousel.component';
import { FooterComponent } from '../../../core/components/footer/footer.component';
import { BackendService } from '../../../core/services/backend.service';
import { SolutionBase } from '../solution-base';
import { NgxTolgeeModule } from '@tolgee/ngx';

@Component({
  selector: 'app-solution-home',
  imports: [MenuBarComponent, CommonModule, ImageCarouselComponent, FooterComponent, NgxTolgeeModule],
  templateUrl: './solution-home.component.html',
  styleUrl: './solution-home.component.scss'
})
export class SolutionHomeComponent extends SolutionBase {
  constructor(router: Router, el: ElementRef, backendService: BackendService) {
    super(router, el, backendService);
  }
}
